import { Link, useBasisForm } from "basis";
import { Error } from "components/Error/Error";
import { Otp } from "components/Otp/Otp";
import { EnhancedAccount } from "library/accounts/types";
import { PersonalDetails } from "pages/ManagePersonalDetails/types";
import { useReducer } from "react";
import { initialState } from "./initialState";
import { updateEmailReducer } from "./reducer";
import { ActionTypes, Page, UpdateEmailFormValues } from "./types";
import { UpdateEmailForm } from "./UpdateEmailForm";
import { UpdateEmailSuccess } from "./UpdateEmailSuccess";
import { VerifyEmail } from "./VerifyEmail";

interface Props {
  account: EnhancedAccount;
  fullPersonalDetails: PersonalDetails;
}

export const UpdateEmailPage = ({ account, fullPersonalDetails }: Props) => {
  const [state, dispatch] = useReducer(updateEmailReducer, initialState);
  const { methods, setError } = useBasisForm<UpdateEmailFormValues>();

  const { getValues } = methods;
  const email = getValues("email");

  switch (state.status) {
    case Page.ERROR: {
      return <Error />;
    }
    case Page.SUCCESS: {
      return <UpdateEmailSuccess {...{ email, account }} />;
    }
    case Page.VERIFY_EMAIL: {
      return (
        <VerifyEmail
          {...{ email, dispatch, verifyEmailUrl: state.verifyUrl }}
        />
      );
    }
    case Page.OTP_REQUIRED: {
      return (
        <Otp
          createSessionUrl={state.createSessionUrl}
          token={state.token}
          onSuccess={() => {
            dispatch({ type: ActionTypes.OTP_SUCCESS });
          }}
          onBackClick={() => {
            dispatch({ type: ActionTypes.BACK });
          }}
          errorFooter={
            <Link
              appearance="primary-button"
              width="256"
              href="/manage-personal-details"
              newTab={false}
            >
              Manage personal details
            </Link>
          }
        />
      );
    }
    default: {
      return (
        <UpdateEmailForm
          account={account}
          fullPersonalDetails={fullPersonalDetails}
          dispatch={dispatch}
          methods={methods}
          setError={setError}
        />
      );
    }
  }
};
